export default {
  jobManagerApi: {
    script: {
      getList: '/api/jobmanager/script/getList',
      saveScript: '/api/jobmanager/script/saveScript',
      updateScript: '/api/jobmanager/script/updateScript',
      delete: '/api/jobmanager/script/delete'
    },
    job: {
      getList: '/api/jobmanager/job/getList',
      saveJob: '/api/jobmanager/job/saveJob',
      updateJob: '/api/jobmanager/job/updateJob',
      delete: '/api/jobmanager/job/delete',
      control: '/api/jobmanager/job/control',
      getEnableJobs: '/api/jobmanager/job/getEnableJobs',
      reworkJobs: '/api/jobmanager/job/reworkJobs'
    },
    jobCluster: {
      getList: '/api/jobmanager/jobCluster/getList',
      getJobClusterDetail: '/api/jobmanager/jobCluster/getJobClusterDetail',
      delete: '/api/jobmanager/jobCluster/delete',
    },
    record: {
      getList: '/api/jobmanager/record/getList',
      handleRecord: '/api/jobmanager/record/handleRecord'
    },
    rework: {
      getList: '/api/jobmanager/rework/getList',
    }

  }

}